module.exports = __webpack_public_path__ + "static/media/cshd0.b3074059.wav";